<template>
  <div class="text-center mt-5">
    <h1><strong>НЕ НАЙДЕНО</strong></h1>
    <br>
    <p>Страница, которую вы ищете, не найдена.</p>
    <br>
    <b-button variant="danger" @click="comeBack">Вернуться назад</b-button>
  </div>
</template>

<script>
export default {
  name: 'pageNotFound',
  props: {
    back: {
      type: String,
      default: '/'
    }
  },
  methods: {
    comeBack () {
      this.$router.push(this.back)
    }
  }
}
</script>
